/**
 *
 * ClubMarkers
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { withLeaflet } from 'react-leaflet';
import isEqual from 'lodash/isEqual';

import { PATH_LOCATION, EMBEDDED } from 'containers/App/constants';
import withRoute from 'containers/withRoute';
import withRest from 'containers/Rest/withRest';
import withClubs from 'containers/Clubs/withEntity';
import withDialog from 'containers/Dialog/withDialog';
import { VIEW_ZOOM } from 'components/Map/constants';
import getPadding from 'utils/getPadding';
import ClubMarker from './ClubMarker';
import getLocation from './getLocation';
import messages from './messages';

class ClubMarkers extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.reportError = this.reportError.bind(this);
    this.hasError = false;
  }

  componentDidMount() {
    this.checkUpdate();
  }

  componentDidUpdate(prevProps) {
    this.checkUpdate(prevProps);
  }

  checkUpdate(prevProps) {
    const { params } = this.props;
    if (params.clubId) {
      this.checkCurrent(prevProps);
      this.checkMapBounds(prevProps);
    }
  }

  /**
   *  Fetch new club if different from currently loaded
   * @param prevProps
   */
  checkCurrent() {
    const { params, clubs, apiGet } = this.props;
    if (clubs.current && (clubs.current.loading || clubs.current.error)) {
      return;
    }
    if (clubs.current && Number(clubs.current.id) === Number(params.clubId)) {
      return;
    }
    apiGet(params.clubId, { onError: this.reportError });
  }

  reportError() {
    const { params, dlgAlert, goTo } = this.props;
    const title = { ...messages.notFound, values: { id: params.clubId } };
    dlgAlert({ title, bsStyle: 'danger' }).then(() => goTo('/home'));
  }

  /**
   * Adapt bounds when new club loaded
   * @param prevProps
   */
  checkMapBounds(prevProps) {
    const { params, clubs, leaflet } = this.props;
    if (
      !clubs.current ||
      clubs.current.loading ||
      clubs.current.error ||
      clubs.current.id !== Number(params.clubId)
    ) {
      return;
    }
    if (
      prevProps &&
      clubs === prevProps.clubs &&
      isEqual(params, prevProps.params)
    ) {
      return;
    }
    const club = clubs.current;
    const clubLocation = getLocation(club, Number(params.locationId));
    if (params.locationId && !clubLocation) {
      this.hasError = true;
      this.reportLocationError();
      return;
    }
    if (EMBEDDED && clubLocation) {
      leaflet.map.setView(clubLocation, VIEW_ZOOM + 2);
      return;
    }
    if (club.locations.length === 1) {
      leaflet.map.setView(clubLocation, VIEW_ZOOM);
      return;
    }
    if (clubLocation) {
      const zoom = leaflet.map.getBoundsZoom(club.locations);
      leaflet.map.setView(clubLocation, zoom - 1);
    } else {
      leaflet.map.fitBounds(club.locations, getPadding());
    }
  }

  reportLocationError() {
    const { params, dlgAlert, goTo } = this.props;
    const title = {
      ...messages.notFoundLocation,
      values: { id: params.locationId },
    };
    dlgAlert({ title, bsStyle: 'danger' }).then(() =>
      goTo(`/club/${params.clubId}`),
    );
  }

  handleClick(locationId) {
    const { goTo, params } = this.props;
    return () => {
      goTo(PATH_LOCATION, {
        clubId: params.clubId,
        locationId,
      });
    };
  }

  render() {
    const { params, clubs } = this.props;
    if (!params.clubId) {
      return null;
    }
    const club = clubs.current;
    if (!club || !club.locations) {
      return null;
    }
    return club.locations.map(loc => (
      <ClubMarker
        key={loc.id}
        club={club}
        loc={loc}
        onClick={this.handleClick(loc.id)}
      />
    ));
  }
}

ClubMarkers.propTypes = {
  params: PropTypes.object.isRequired,
  apiGet: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  dlgAlert: PropTypes.func.isRequired,
  clubs: PropTypes.object.isRequired,
  leaflet: PropTypes.object.isRequired,
};

export default compose(
  withClubs,
  withDialog,
  withRest,
  withLeaflet,
  withRoute,
)(ClubMarkers);
